import React from "react"
import { ReportFormPage } from "./ReportFormPage"

export const ReportEditPage = React.memo(() => <ReportFormPage isCreation={false} />)
